import { zimbaApi } from '@/infrastructure/Configuration'

const defaultGetConfig = {
  headers: { 'Content-Type': 'application/json' },
  data: {}
}

export default class ZimbaService {
  constructor (httpClient) {
    this.httpClient = httpClient
  }

  async searchCities (term) {
    const { data: { cities } } = await this.httpClient.get(`${zimbaApi}/search/${term}`, defaultGetConfig)
    return cities
  }

  async searchCrossHotels (term) {
    const { data: { hotels } } = await this.httpClient.get(`${zimbaApi}/cross/search/${term}`, defaultGetConfig)
    return hotels
  }

  async searchHotelsByCity (cityCode) {
    const { data: { hotels } } = await this.httpClient.get(`${zimbaApi}/hotels?city=${cityCode}`, defaultGetConfig)
    return hotels
  }

  async getHotelInfo (hotelCode) {
    const { data: { hotels } } = await this.httpClient.get(`${zimbaApi}/info/hotels?code=${hotelCode}`, defaultGetConfig)
    return hotels[0]
  }

  async getDestinations () {
    const { data: { destinations } } = await this.httpClient.get(`${zimbaApi}/destinations`, defaultGetConfig)
    return destinations
  }
}
